import { useNearbySearch } from "./use-nearby-search";
import { usePlaceSuggestionResults } from "./use-place-suggestion-results";

export const usePlaceSuggestions = ({ trimmedSearch }) => {
  const { nearbyOnly, handleNearbyOnlyChange, userLocation } = useNearbySearch();
  const {
    topPlace,
    placeSuggestions,
    isSuggestionLoading,
    fetchPlaceSuggestions,
  } = usePlaceSuggestionResults({
    trimmedSearch,
    nearbyOnly,
    userLocation,
  });

  return {
    nearbyOnly,
    handleNearbyOnlyChange,
    userLocation,
    topPlace,
    placeSuggestions,
    isSuggestionLoading,
    fetchPlaceSuggestions,
  };
};
